var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 102,
    viewBox: "0 0 110 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_29844",
    "data-name": "Group 29844",
    transform: "translate(-918.5 -167.71)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17069",
    "data-name": "Rectangle 17069",
    width: 110,
    height: 102,
    transform: "translate(918.5 167.71)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28843",
    "data-name": "Group 28843",
    transform: "translate(-306.363 1154.164)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28842",
    "data-name": "Group 28842",
    transform: "translate(1225.364 -982.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M1233.01-891.618h-7.646v2.874h109v-2.88h-52.78v-63.652h42.162v.506l0,8.4,0,4.924q0,12.62-.009,25.241c0,.178,0,.357,0,.535v.049c0,.105,0,.207,0,.306.629.007,1.318.011,2.164.011h.825v-1.942c0-12.776.005-25.986,0-38.979a2.594,2.594,0,0,0-.429-1.733,2.7,2.7,0,0,0-1.771-.429l-43.553.038c-2.179,0-2.481.311-2.481,2.543v63.9l-.459.043-1.491.141c-.12.011-.23.024-.334.036l-.024,0a7.751,7.751,0,0,1-.933.069h-2.563l-4.406,0H1265.4l-9.431,0c-6.592,0-11.891.005-16.676.016h-.017a3.361,3.361,0,0,1-2.417-.88,3.449,3.449,0,0,1-.883-2.55c.015-23.419.011-46.843-.012-69.621a3.3,3.3,0,0,1,2.64-3.474c8.767-2.332,17.642-4.712,26.224-7.013l9.821-2.633a9.3,9.3,0,0,1,.932-.186c.131-.021.271-.044.427-.073l1.941-.354.6-.109v8.452h2.951v-1.573c0-2.691,0-5.348,0-8,0-1.745-.459-2.233-.6-2.341a1.509,1.509,0,0,0-.874-.2,5.842,5.842,0,0,0-1.479.229c-14.469,3.891-29.112,7.839-44.09,11.878-1.121.3-1.39.645-1.442,1.833-.023.534-.022,1.077-.02,1.652v.405q.008,35.257.017,70.512v4.037Z",
    transform: "translate(-1225.364 982.164)",
    fill: "#919191"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M1312.592-832.383c0,1.831-.008,3.561.045,5.336.033,1.121,1.457,1.6,2.045,1.61,1.4.025,2.8.029,3.862.029l1.663,0h11.913v-9.523h-19.526v1.139Q1312.594-833.086,1312.592-832.383Zm2.278.232v-.505h14.97v4.965h-8.2l-1.129,0h-.372l-1.605,0c-1.269,0-2.24-.005-3.147-.018l-.491-.007-.009-.491C1314.866-829.458,1314.867-830.682,1314.87-832.151Z",
    transform: "translate(-65.143 -109.955)",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M1491.524-834.692v9.464h10.448c2.034,0,4.437,0,6.831-.032.728-.009,2.167-.616,2.208-1.7.065-1.713.059-3.448.054-5.126v-.022q0-.724,0-1.449v-1.139Zm17.239,6.666-.011.489-.49.005c-2.245.024-4.525.027-6.26.027h-8.2v-4.906h14.982l0,.5C1508.791-830.526,1508.792-829.28,1508.763-828.026Z",
    transform: "translate(-198.776 -110.136)",
    fill: "#919191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M1332.172-760.41v-9.5l-6.912,0-3.235,0c-2.887,0-5.084.007-7.125.021-.58,0-2.185.381-2.224,1.557-.06,1.811-.056,3.645-.052,5.418,0,.461,0,.913,0,1.365v1.139Zm-17.249-6.708.01-.493.493,0c1.91-.012,3.956-.018,6.631-.018l3.2,0,4.129,0h.506v4.94H1314.9v-.505C1314.9-764.527,1314.9-765.831,1314.923-767.118Z",
    transform: "translate(-65.166 -158.517)",
    fill: "#919191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M1499.464-770.717h-2.745l-2.839,0c-.312,0-.62.021-.918.042l-.038,0c-.126.009-.256.018-.39.025l-1.078.058v9.385h19.583v-1.139c0-.574,0-1.144-.007-1.711v-.1c-.009-1.456-.018-2.831.026-4.234a2.337,2.337,0,0,0-.559-1.755,2.436,2.436,0,0,0-1.843-.6V-771h0l0,.253C1505.631-770.719,1502.582-770.717,1499.464-770.717Zm9.316,2.251-.012.522c-.029,1.274-.021,2.562-.013,3.808v.144l0,.509-.509,0h-14.513v-4.955h6.176c3.117,0,5.73,0,8.346-.024Z",
    transform: "translate(-198.726 -157.706)",
    fill: "#919191"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M1311.869-901.226v9.865h19.973v-9.865Zm17.188,7.08h-14.4v-4.042h14.4Z",
    transform: "translate(-64.604 -60.447)",
    fill: "#919191"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M1312.81-704.151v9.351h19.473v-9.351ZM1330-701.366v4.287h-14.916v-4.794H1330Z",
    transform: "translate(-65.307 -207.628)",
    fill: "#919191"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M1491.351-704.007v9.325h19.517v-9.325Zm17.239,2.785v4.261h-14.96v-4.767h14.96Z",
    transform: "translate(-198.647 -207.736)",
    fill: "#919191"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M1600.983-685.354c0,1.588-.008,3.088.032,4.61a2.023,2.023,0,0,0,1.753,1.786c1.283.031,2.517.036,3.556.036l1.31,0h.165l1.483,0h1.139v-9.037h-9.436v1.139Q1600.985-686.079,1600.983-685.354Zm2.278.174v-.5h4.881v4.481h-.505l-1.3,0c-1.033,0-1.824,0-2.565-.016l-.491-.007-.008-.491C1603.256-682.818,1603.258-683.937,1603.261-685.18Z",
    transform: "translate(-280.521 -219.718)",
    fill: "#919191"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.5d7fd8841e41aa88a51290e74a95f1fa.svg";
export { ForwardRef as ReactComponent };